import React from 'react';
import { Fab, IconButton } from '@material-ui/core';
import FacebookCircularProgress from './FacebookCircularProgress';
import { 
            GetApp as GetAppIcon     
} from '@material-ui/icons';
import { Page, Text, View, Document, StyleSheet, Font, usePDF, Image as ImagePdf } from '@react-pdf/renderer';

const PdfThermal = ({data, Service, InfoEmpresa, HandleClickPdf, isSmall })=>{

    Font.register({family: 'OpenSans', fonts: [
        { src: 'fonts/OpenSans-Light.ttf' }, // font-style: normal, font-weight: normal
        { src: 'fonts/OpenSans-Italic.ttf', fontStyle: 'italic' },
        { src: 'fonts/OpenSans-Bold.ttf', fontWeight: 'bold' },
        { src: 'fonts/OpenSans-Regular.ttf', fontWeight: 'normal' },
        { src: 'fonts/OpenSans-Regular.ttf', fontWeight: 'black' },
    ]});


    const styles = StyleSheet.create({
        header:{
            fontFamily:'OpenSans',
            marginTop:20,
            fontSize:11,
            paddingTop:5,
            textAlign:'center',
            lineHeight:1.5
        },
        title:{
            fontSize:12,
            fontWeight:'bold'
        },
        subTitleW:{
            fontSize:11,
            fontWeight:'bold'
        },
        subTitleW7:{
            fontSize:11,
            fontWeight:'bold',
            textAlign:'center'
        },
        subTitleW5:{
            fontSize:10,
            fontWeight:'bold'
        },
        subtitleI:{
            fontStyle:'italic'
        },
        body:{
            fontFamily:'OpenSans',
            marginTop:5,
            padding:5,
            lineHeight:1.8
        },
        boxImage:{
            marginTop:5,
            padding:5,
            display:'flex',
            justifyContent:'center',
            alignItems:'center'
        },
        textRight:{
            marginTop:-19,
            marginLeft:68,
            fontSize:10
        },
        subTitleW_D:{
            fontSize:11,
            fontWeight:'bold',
            marginTop:10
        },
        textRight_N:{
            fontSize:9,
            padding:2,
            textAlign:'justify'
        },
        subTitleW2_D:{
            marginTop:10,
            fontSize:10,
            fontWeight:'bold'
        },
        subTitleW2_UP:{
            marginLeft:146,
            marginTop:-19,
            fontSize:10,
            fontWeight:'bold'
        },
        subTitle2_D:{
            fontSize:10,
        },
        subTitle2_UP:{
            marginLeft:145,
            marginTop:-19,
            fontSize:10,
        },
        subTitle2_UP2:{
            marginLeft:140,
            marginTop:-19,
            fontSize:10,
            fontWeight:'bold',
            textAlign:'right'
        },
        subTitleW2_UP2:{
            marginLeft:140,
            marginTop:-19,
            fontSize:10,
            fontWeight:'bold',
            textAlign:'right'
        },
        subTitleW3:{
            fontSize:9,
            fontWeight:'bold',
            textAlign:'center'
        },
        subTitleW4:{
            fontSize:8,
            fontWeight:'black',
            textAlign:'center'
        },
        lineTop:{
            position:'relative',
            top:15
        },
        lineDown:{
            position:'relative',
            top:-15
        },
        image:{
            width:100,
            height:100
        },
        padding2:{
            padding:2,
            textAlign:'justify'
        },
        textRight_NB:{
            fontWeight:'black',
            fontSize:9,
            padding:2,
            textAlign:'justify'
        },
        subTitle2_DB:{
            fontSize:10,
            fontWeight:'black',
        },
        
    });

    const MyDoc = (
        <Document>
            <Page size={[650.72, 192]} orientation="landscape" wrap>
                <View style={styles.header}  wrap>
                    <Text style={styles.title} > INTERCOM-MANABI </Text>
                    <Text style={styles.subtitleI} > Servicio de Telecomunicaciones </Text>
                    <Text style={styles.subTitleW5} > 9 DE JULIO Y AV. FRANCISCO CUADRO </Text>
                    <Text style={styles.subTitleW5} > MANTA - MANABI </Text>
                </View>
                <View style={styles.body}  wrap>
                    <Text style={styles.subTitleW7} >COMPROBANTE DE PAGO </Text>
                    <Text style={styles.subTitleW} >{`N°:  ${data.NumberReciept}`} </Text>
                    <Text style={styles.subTitleW} >FECHA: </Text>
                    <Text style={styles.textRight} >{data.Status === 'Pendiente' ? 'PENDIENTE' : data.FechaPago.split('T')[0]} </Text>
                    <Text style={styles.subTitleW} >CLIENTE: </Text>
                        <View style={styles.padding2}>
                            <Text style={styles.textRight_NB} wrap>{data.Nombres} </Text>
                        </View>
                    <Text style={styles.subTitleW_D} >DIRECCION: </Text>
                    <View style={styles.padding2}>
                        <Text style={styles.textRight_N} wrap>{Service.Direccion} </Text>
                    </View>
                    <Text style={styles.lineTop}>_____________________________________________</Text>
                    <Text style={styles.subTitleW2_D} >DETALLES</Text>
                    <Text style={styles.subTitleW2_UP} >VALOR </Text>
                    <Text style={styles.lineDown}>_____________________________________________</Text>
                    <Text style={styles.subTitle2_DB} >{`${data.MesServicio.toUpperCase()} DE ${data.ageWork}`}</Text>
                    <Text style={styles.subTitle2_UP2} >{`$${data.Status === 'Pendiente' || data.Status === 'PagoRestante' ? data.Valor ? parseFloat(data.Valor).toFixed(2) : '0.00' : data.ValTotal}`}</Text>
                    <Text style={styles.subTitleW2_D} >VALOR CANCELADO: </Text>
                    <Text style={styles.subTitleW2_UP2} >{`$${data.Status === 'Pendiente' || data.Status === 'PagoRestante' ? data.Valor ? parseFloat(data.Valor).toFixed(2) : '0.00' : data.ValTotal}`} </Text>
                    <Text style={styles.subTitleW2_D} >VALOR PENDIENTE: </Text>
                    <Text style={styles.subTitleW2_UP2} >{`$${data.Status === 'Pendiente' ? data.Valor ? parseFloat(data.ValPlan - data.Valor).toFixed(2) : '0.00' : '0.00'}`} </Text>
                </View>
                <View style={styles.body}  wrap>
                    <Text style={styles.subTitleW3} >SERVICIO AL CLIENTE: 0962771752 </Text>
                </View>
                <View style={styles.boxImage}  wrap>
                    <ImagePdf source='qr-promomedios.png' style={styles.image} />
                </View>
                <View style={styles.body}  wrap>
                    <Text style={styles.subTitleW3} >Solicita tu Factura Electrónica en: </Text>
                    <Text style={styles.subTitleW4} >http://promomediossa.com/factura-electronica/ </Text>
                </View>
            </Page>
        </Document>
    );

    const [ instance ] = usePDF({ document: MyDoc });

    if (instance.loading) return <FacebookCircularProgress size={isSmall ? 20 : 30} style={{marginTop:5}} />;

    if (instance.error) return <div>Something went wrong: {instance.error}</div>;

    if(isSmall){
        return (
            <IconButton 
                color='primary' 
                href={instance.url} 
                onClick={HandleClickPdf} 
                size='small' 
                style={{ backgroundColor:'#fff' }}
                target='_blank' 
                >
                <GetAppIcon />
            </IconButton>
        );
    }else{
        return (
            <Fab href={instance.url} onClick={HandleClickPdf} size='small' color='primary' target='_blank'>
                <GetAppIcon />
            </Fab>
        );
    }
};

export default PdfThermal;